import { render, staticRenderFns } from "./flat-drop-down-box.vue?vue&type=template&id=fabc8eac&scoped=true&"
import script from "./flat-drop-down-box.vue?vue&type=script&lang=ts&"
export * from "./flat-drop-down-box.vue?vue&type=script&lang=ts&"
import style0 from "./flat-drop-down-box.vue?vue&type=style&index=0&id=fabc8eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabc8eac",
  null
  
)

export default component.exports